export enum LegalBasisSearchFieldsEnum {
  DOCUMENT_NAME = 'DOCUMENT_NAME',
  DOCUMENT_AGENCY = 'DOCUMENT_AGENCY',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  DOCUMENT_NUMBER_MINJUST = 'DOCUMENT_NUMBER_MINJUST',
}
